<template>
  <div class="login-page">
        <img class="login-bg" src="https://image.begonia.cafe/tx/00166.webp" referrerpolicy="no-referrer" />
      <div class="login-mask">
				<div class="login-panel">
					<p class="login-title">登录</p>
					<div class="login-field">
						<p class="login-label">账号</p><el-input v-model="account" placeholder="请输入账号"></el-input>
					</div>
					<div class="login-field login-field--last">
						<p class="login-label">密码</p><el-input type="password" v-model="password" placeholder="请输入密码"></el-input>	
					</div>
					 <el-button type="primary" class="login-submit" @click="login()">登录</el-button>
					 <el-button plain class="console-entry-button" @click="openConsole">进入控制台</el-button>
				</div>
      </div>
  </div>
 </template>
<script>
import {post} from "../axios/request.js"
export default {
  data() {
    return {
      account:"",
	  password:"",
    }
  },
  mounted() {
    if(localStorage.getItem("token")!=null&&localStorage.getItem("token").length==18){
        post("/api/admin/jugetoken",{token:localStorage.getItem("token")}).then((res)=>{
            if(res.data.code==1002){

            }else{
                this.$router.replace({path:"/index"})
            }
        })
    }
  },
  methods: {
	  login(){
		post("/api/admin/login",{account:this.account,password:this.password}).then((res)=>{
			if(res.data.code==1001){
				var time = new Date().getTime()+3600*1000*2;
				localStorage.setItem("time",time);
				localStorage.setItem("token",res.data.token);
				this.$router.replace({path:"/index"})
			}else{
				this.$message.error('账号或密码错误');
			}
		})
	  },
    openConsole(){
      this.$router.push({path:"/console"})
    }
  }
}
</script>

<style scoped>
.login-page {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #171511;
}

.login-bg {
  position: fixed;
  inset: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scale(1.02);
  filter: saturate(0.92) contrast(1.04);
}

.login-mask {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  background:
    linear-gradient(120deg, rgba(17, 15, 12, 0.74), rgba(17, 15, 12, 0.34)),
    linear-gradient(315deg, rgba(0, 168, 150, 0.18), transparent 44%);
}

.login-panel {
  position: relative;
  width: 420px;
  min-height: 410px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 38px 42px 34px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.52);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 28px 78px rgba(0, 0, 0, 0.28);
  backdrop-filter: blur(18px);
}

.login-panel::before {
  content: "";
  position: absolute;
  inset: 0 0 auto;
  height: 4px;
  background: linear-gradient(90deg, #1677ff, #00a896, #f59f00);
}

.login-title {
  margin: 0 0 26px;
  color: #18212f;
  font-size: 24px;
  line-height: 1.2;
  font-weight: 900;
  text-align: center;
  letter-spacing: 0;
}

.login-field {
  width: 100%;
  margin-bottom: 20px;
}

.login-field--last {
  margin-bottom: 30px;
}

.login-label {
  margin: 0 0 8px;
  color: #4a5568;
  font-size: 14px;
  font-weight: 700;
}

.login-panel ::v-deep .el-input__inner {
  height: 42px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.92);
}

.login-submit {
  width: 100%;
  height: 42px;
}

.console-entry-button {
  width: 100%;
  margin-top: 12px;
  margin-left: 0;
  height: 42px;
  background: rgba(255, 255, 255, 0.72);
}

</style>
